import { Option, QuizQuestionForm, QuizQuestionFormError, QuizQuestionFormStateError } from '@/models/QuizQuestion';
import { QuizResult } from '@/models/QuizResult';
import { LocaleData } from '@/translations/LocaleData';
import * as Yup from 'yup';

const errorToKey: Record<QuizQuestionFormError, string> = {
    [QuizQuestionFormError.SAME_QUESTION_DESCRIPTION]: 'descriptionError',
};

export const formInitialState = (order: number): QuizQuestionForm => ({
    order: order,
    image: '',
    description: '',
    options: [
        {
            description: '',
            result: null,
        },
        {
            description: '',
            result: null,
        },
    ],
});

export const formErrors: QuizQuestionFormStateError = {
    descriptionError: undefined,
};

export const formSchema: Yup.ObjectSchema<QuizQuestionForm> = Yup.object().shape<QuizQuestionForm>({
    order: Yup.number().required(),
    description: Yup.string().when(['$existingDescriptions', '$strings'], (existingDescriptions: string[], strings: LocaleData) =>
        Yup.string()
            .test(
                QuizQuestionFormError.SAME_QUESTION_DESCRIPTION,
                strings.QUESTION_DESCRIPTION_IN_USE,
                (value: string) => !existingDescriptions.some((description: string) => description.toUpperCase() === value.toUpperCase()),
            )
            .trim()
            .required(),
    ),
    image: Yup.string()
        .trim()
        .notRequired(),
    options: Yup.array<Option>().of(
        Yup.object().shape<Option>({
            description: Yup.string()
                .trim()
                .required(),
            result: Yup.mixed<QuizResult>().required(),
        }),
    ),
});

export const validate = (formState: QuizQuestionForm, context: any) => {
    return formSchema
        .validate(formState, {
            context,
            abortEarly: false,
        })
        .catch((err) =>
            Promise.reject(
                (err.inner || []).reduce((acc: QuizQuestionFormStateError, error: Yup.ValidationError) => {
                    const k = error.type as QuizQuestionFormError;
                    const key = errorToKey[k] as keyof QuizQuestionFormStateError;
                    if (key) acc[key] = error.message;
                    return acc;
                }, {} as Record<string, string>),
            ),
        );
};
